import { FC } from 'react';
import { Link } from 'react-router-dom';
import { linkOrigem, origemDoPainel, type ChavePainel } from '@/config/origemDados';

/**
 * "De onde vêm estes dados", no topo de cada painel: de que parte do Datasul sai
 * cada número, quando foi copiado e o link para a página que explica número a número.
 * O texto vem do catálogo `config/origemDados.ts`, o mesmo da página.
 */
const OrigemDadosCard: FC<{ chave: ChavePainel }> = ({ chave }) => {
  const origem = origemDoPainel(chave);
  return (
    <aside
      aria-label="De onde vêm estes dados"
      data-testid={`origem-${chave}`}
      className="flex flex-col gap-3 rounded-xl border border-theme-border bg-surface-card p-4 text-sm sm:flex-row sm:items-start"
    >
      <span aria-hidden className="material-symbols-outlined text-[20px] leading-none text-accent">
        {origem.daPlataforma ? 'edit_note' : 'database'}
      </span>
      <div className="min-w-0 flex-1">
        <p className="font-semibold text-content-primary">De onde vêm estes dados</p>
        <p className="mt-0.5 text-content-secondary">{origem.resumo}</p>
        <p className="mt-1 text-xs text-content-muted">
          {origem.daPlataforma
            ? 'Aparece na hora em que é registrado.'
            : 'Cópia do Datasul feita toda noite, recalculada todo dia às 06:00.'}
        </p>
      </div>
      <Link
        to={linkOrigem(chave)}
        data-testid={`origem-${chave}-link`}
        className="shrink-0 whitespace-nowrap font-medium text-accent hover:underline"
      >
        Entenda cada número →
      </Link>
    </aside>
  );
};

export default OrigemDadosCard;
